function HomeBanner() {
  return (
    <div className="homeBanner">
      <div className="circleOne"></div>
      <div className="hBTextBox">
        <div className="hBText">
          <h1>Check Us Out</h1>
          <article>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </article>
        </div>
        <a href="https://www.instagram.com/skynlodge/" class="button">
          Visit Our Store
        </a>
      </div>
      <div className="circleTwo"></div>
    </div>
  );
}
export default HomeBanner;
